import Swiper, { Autoplay, Navigation, Pagination, EffectFade } from "swiper";

Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);

// 客室詳細ページのMV
// new Swiper('.p-room-lower-mv', {
//   slidesPerView: 2,
//   loop: true,
//   speed: 1500,
//   effect: 'fade',
//   fadeEffect: {
//     crossFade: true
//   },
//   autoplay: {
//     delay: 3500,
//   },
// });

const slideLength = document.querySelectorAll(
  ".p-room-lower-mv .swiper-slide"
).length;

new Swiper(".p-room-lower-mv", {
  slidesPerView: 1,
  centeredSlides: true,
  loop: true,
  speed: 1500,
  autoplay: {
    delay: 3500,
  },
  breakpoints: {
    769: {
      slidesPerView: 1.918347,
      spaceBetween: 10,
      loopedSlides: 3,
    },
  },
});

new Swiper(".p-room-deluxeroom-point__slide", {
  slidesPerView: 1,
  loop: true,
  speed: 1500,
  spaceBetween: 10,
  autoplay: {
    delay: 3500,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    769: {
      pagination: false,
      loop: false,
      spaceBetween: 0,
      slidesPerView: 3,
      slidesPerView: "auto",
    },
  },
});

// if (slideLength > 1) {
//   const swiper = new Swiper('.p-room-lower-mv', {
//     slidesPerView: 2.5,
//     centeredSlides : true,
//     loop: true,
//     speed: 1500,
//     effect: 'fade',
//     fadeEffect: {
//       crossFade: true
//     },
//     autoplay: {
//       delay: 3500,
//     },
//   })
// }
